import { isMobile } from 'src/scripts/utils/check-media'
import { transitionToPromise } from 'src/scripts/utils/utils'

const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger'
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen'
const ZOOM_OUT_CLASSNAME = 'animate--zoom-out'
const KEEP_OBSERVE_ATTRIBUTE = 'data-keep-observe-animation'
const REMOVE_ANIMATION_CLASS_ATTRIBUTE = 'data-remove-animation-class'
const IS_SLIDE_CLASSNAME = 'slider-grid__slide'
const REGULAR_IMGAE_ZOOM_CLASSNAME = 'zoom'

function onIntersection(
  elements: IntersectionObserverEntry[],
  observer: IntersectionObserver,
) {
  elements.forEach((element, index) => {
    const elementTarget = element.target

    if (element.isIntersecting) {
      handleIntersecting(elementTarget, index, observer)
    } else {
      handleNonIntersecting(elementTarget, observer)
    }
  })
}

function handleIntersecting(
  elementTarget: Element,
  index: number,
  observer: IntersectionObserver,
) {
  if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
    elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
    elementTarget.setAttribute('style', `--gsc-animation-order: ${index};`)
  }

  if (
    elementTarget.hasAttribute(REMOVE_ANIMATION_CLASS_ATTRIBUTE) ||
    elementTarget.classList.contains(REGULAR_IMGAE_ZOOM_CLASSNAME)
  ) {
    removeAnimationClasses(elementTarget)
  }

  if (!elementTarget.hasAttribute(KEEP_OBSERVE_ATTRIBUTE)) {
    observer.unobserve(elementTarget)
  }
}

function handleNonIntersecting(
  elementTarget: Element,
  observer: IntersectionObserver,
) {
  if (
    isMobile() &&
    (elementTarget.classList.contains(IS_SLIDE_CLASSNAME) ||
      elementTarget.classList.contains(ZOOM_OUT_CLASSNAME)) &&
    elementTarget.getBoundingClientRect().left >
      document.body.getBoundingClientRect().width
  ) {
    elementTarget.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
    observer.unobserve(elementTarget)
  } else {
    elementTarget.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
  }
}

async function removeAnimationClasses(elementTarget: Element) {
  await transitionToPromise(elementTarget)
  elementTarget.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  elementTarget.removeAttribute('style')
}

function getObserverOptions() {
  const asidePaddings = getComputedStyle(document.body).getPropertyValue(
    '--gsc-aside-padding-size',
  )

  return {
    rootMargin: `0px -${asidePaddings} -50px -${asidePaddings}`,
  }
}

function initializeScrollAnimationTrigger() {
  const animationTriggerElements = Array.from(
    document.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
  )

  if (animationTriggerElements.length === 0) return

  const observer = new IntersectionObserver(
    onIntersection,
    getObserverOptions(),
  )

  animationTriggerElements.forEach(element => observer.observe(element))
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger()
})
